import * as S from "./MainContent.style";

interface MainContentProps {
  children?: React.ReactNode;
  contentItem?: React.ReactNode;
  commentFloat?: boolean;
}

export const MainContent = ({
  children,
  contentItem,
  commentFloat,
}: MainContentProps) => {
  return (
    <S.MainContent $commentFloat={commentFloat}>
      {contentItem && <S.ContentItemBox>{contentItem}</S.ContentItemBox>}

      {children}
    </S.MainContent>
  );
};
